import $ from 'jquery';

import animatedPush from "./animatedPush";
import 'slick-carousel';

let onglet = {
    init() {
        if ($('body').hasClass('page-node-type-global-search')){
            this.search();
        }

        if ($('body').hasClass('page-type-product') || $('body').hasClass('page-node-type-homepage')){
            this.product();
        }
    },

    product() {
        $('.onglet-content > div').fadeOut(0);
        $('.onglet-content > div:first-child').slideDown(0).fadeTo(0, 1);
        $('.onglet-title:first-child').addClass('active');

        $('.onglet-title').click(function () {
            let id = $(this).attr('id');
            $('.onglet-title').removeClass('active');
            $('.onglet-title#' + id).addClass('active');


            setTimeout(function () {
                $('.slider-related-product').slick('refresh');
                animatedPush.init();
            }, 500);

            $('.onglet-content > div').fadeTo(300, 0).slideUp(0);
            $('.onglet-content .onglet-' + id).slideDown(0);
            $('.onglet-content .onglet-' + id).delay(300).fadeTo(300, 1);
        });
    },

    search() {
        $('.onglet-content > div').addClass('hide');
        $('.onglet-content > div:first-child').removeClass('hide');
        $('.onglet-title:first-child').addClass('active');

        $('.onglet-title').click(function () {
            let id = $(this).attr('data-id');
            $('.onglet-title').removeClass('active');
            $(".onglet-title[data-id='" + id + "']").addClass('active');

            if ($('div').hasClass('page-product') ||
                $('body').hasClass('page-node-type-homepage')) {
                $('.slider-related-product').slick('refresh');
            }

            $('.onglet-content > div').addClass('hide');
            $('.onglet-content .onglet-' + id).removeClass('hide');
            $("html, body").animate({scrollTop: $('.content .onglet').offset().top - 300 }, 600);
        });

        if ($('body').hasClass('page-node-type-global-search')) {
            let params = drupalSettings.path.currentQuery;
            if (params.hasOwnProperty('type')) {
                if (params.type == 'infos') {
                    $(".onglet-title[data-id='article-" + params.type + "']").trigger("click");
                }
                if (params.type == 'probleme') {
                    $(".onglet-title[data-id='article-" + params.type + "']").trigger("click");
                }
            }
        }
    }
}

export default onglet;
